"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var activity_1 = require("ayvri-api/lib/shared/activity");
var fn_1 = require("ayvri-std/lib/fn");
var env_1 = require("../helpers/env");
// tslint:disable-next-line:no-var-requires
exports.activityTypes = require('ayvri-vera/lib/activityTypes.json');
exports.activityMap = new Map();
// set all the keys to the default values in activity types
Object.keys(exports.activityTypes).forEach(function (a) {
    exports.activityMap.set(a, exports.activityTypes[a]);
});
exports.activityMap.set('Mountain Bike', 'MTB');
exports.activityMap.set('Road Bike', 'Cycle');
exports.activityMap.set('Dirt Bike', 'Motorcycle');
exports.activityMap.set('Drive', 'Car');
exports.activityMap.set('Camel', 'Equestrian');
exports.activityMap.set('Horse Riding', 'Equestrian');
exports.activityMap.set('Trail Run', 'Run');
exports.activityMap.set('XC Ski', 'Alpine');
exports.activityMap.set('Snowboard', 'Alpine');
exports.activityMap.set('Ski', 'Alpine');
exports.activityMap.set('Snowmobile', 'Alpine');
exports.activityMap.set('SnowShoe', 'Alpine');
exports.activityMap.set('Climb', 'Hike');
exports.activityMap.set('Mountaineer', 'Hike');
exports.activityMap.set('Walk', 'Hike');
exports.activityMap.set('Trek', 'Hike');
exports.activityMap.set('Kayak', 'Paddle');
exports.activityMap.set('Canoe', 'Paddle');
exports.activityMap.set('Row', 'Paddle');
exports.activityMap.set('Motor Boat', 'Motorboat');
exports.activityMap.set('Sailing', 'Motorboat');
exports.activityMap.set('Waterski', 'Water');
exports.activityMap.set('Wakeboard', 'Water');
exports.activityMap.set('Kitesurf', 'Windsurf');
exports.activityMap.set('Surf', 'Water');
exports.activityMap.set('Swim', 'Swim');
exports.activityMap.set('Birds', 'Bird');
exports.activityMap.set('Aviary', 'Bird');
exports.activityMap.set('Hang Glide', 'Hang-glide');
exports.activityMap.set('Sailplane', 'Glide');
exports.activityMap.set('UAV', 'Drone');
exports.activityMap.set('Aerial', 'Clouds');
exports.activityMap.set('Mixed', 'Clouds');
exports.activityMap.set('Hike + Glide', 'Paraglide');
exports.activityMap.set('Other', 'Ground');
exports.mapActivitiesToImage = function (str) {
    return fn_1.def('Ground', exports.activityMap.get(str));
};
exports.getGenreForDefaultImage = function (str) {
    var actType = activity_1.activityToGenreMap.get(str) || 'Air';
    if (actType === 'Mixed') {
        actType = 'Air';
    }
    return actType;
};
exports.getActivityTypeFromArray = function (activities) {
    if (!activities || activities.length === 0) {
        return undefined;
    }
    var act = activities[0];
    if (typeof act === 'string') {
        return undefined;
    }
    return act.activityType || undefined;
};
exports.getThumbnailForScene = function (activityType, i) {
    if (!activityType) {
        // this shouldn't happen but maybe a live track or tracks deleted, etc etc.
        return env_1.env().staticSrcPath() + '/assets/images/backgrounds/Air_' + (i % 2 === 0 ? 1 : 2) + '.png';
    }
    return (env_1.env().staticSrcPath() +
        '/assets/images/backgrounds/' +
        exports.getGenreForDefaultImage(activityType) +
        '_' +
        (i % 2 === 0 ? 1 : 2) +
        '.png');
};
